module.exports = __webpack_public_path__ + "img/mentor-avatar.0cc331a7.svg";